import { createContext, useContext } from 'react';

// Marks a subtree as a patient-GLOBAL overview surface: the patient-chart Overview widgets and the
// clinical note's right-sidebar Patient History tab. Those surfaces render health-summary rows, not
// the open note's aggregate-data pins, so a delete performed in them has to be global. Shared hooks
// and modals read this to send `fromOverview: true` instead of a clinicalNoteId/appointmentId, and
// to skip the force-save-the-note step that only makes sense for an in-note edit.
export const OverviewSurfaceContext = createContext({ fromOverview: false });

export const OVERVIEW_SURFACE = Object.freeze({ fromOverview: true });

export const useOverviewSurface = () => useContext(OverviewSurfaceContext)?.fromOverview === true;
